export default function Stack({
  children,
  gap = "md",
  as: Component = "div",
  className = "",
}) {
  const gaps = {
    sm: "gap-4",
    md: "gap-6",
    lg: "gap-8",
    xl: "gap-12",
  };

  return (
    <Component
      className={`
        flex flex-col
        ${gaps[gap]}
        ${className}
      `}
    >
      {children}
    </Component>
  );
}